import { _, Obscura } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import VoucherType from "../models/VoucherType";

const VoucherTypesProxy = Obscura.extend({
  getFilterCount() {
    return this.getFilters().length;
  },

  filterByType(types) {
    return this.filterBy("type", (model) => _.contains(types, model.get("type")));
  },

  filterByQuery(val) {
    return this.filterBy("query", function (model) {
      return (
        model.get("id").toString().indexOf(val) >= 0 ||
        (model.attributes.name !== null ? model.get("name").indexOf(val) >= 0 : false) ||
        (model.attributes.description !== null
          ? model.get("description").toLowerCase().indexOf(val) >= 0
          : false)
      );
    });
  },

  filterByStatus(status) {
    return this.filterBy("type", (model) => model.get("status") === status);
  },
});

export default InboomaBaseAsyncCollection.extend({
  collectionName: "voucherTypes",
  model: VoucherType,
  url: "/voucher_types",
  proxy: VoucherTypesProxy,
  _pagination: {
    // Updated after each request (response.pagination)
    current_page: 0,
    sort: "id",
    sortDirection: "desc",
    has_next_page: false,
    has_prev_page: false,
    count: 0, // not relevant; response total entities count
    limit: 100,
  },
});
